module.exports = {"title":"Your Accounts Are Now Connected","closeCta":"Close"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/Facebook/facebookConfirmationModalCopy.json
// module id = 2746
// module chunks = 63